import React, { useState } from 'react';


const UserProfilePopupHOC = (Component:any) => 
function Comp(props:any){
    const [showUserProfilePopup,setShowUserProfilePopup] = useState<boolean>(false);

    const UserProfileToggleHandler = () => {
        setShowUserProfilePopup(!showUserProfilePopup);
    }
	
	return <Component showUserProfilePopup={showUserProfilePopup} UserProfileToggleHandler={UserProfileToggleHandler} {...props}/>;
};

export default UserProfilePopupHOC;   